import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import DrawCounter from 'components/home-page/DrawCounter';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';

const ComponentPreview = () => {
  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Draw Countdown </h3>
        <p>
          <>
            The draw countdown component, as used on the homepage. It will take
            up the full width of its container, and is designed to be placed on
            a background of a different colour to the rest of the page.
          </>
        </p>
        <div style={{ width: '20%', padding: 16, margin: 'auto' }}>
          <DrawCounter
            targetDate={new Date(new Date().getTime() + 1000 * 60 * 60 * 24)}
          />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Draw Countdown',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
